/**
 * Shared country list covering all regions Kanal serves:
 * Caribbean, Canada, United States, South America, and Africa.
 *
 * Ordered: JM first, then US, CA, then rest alphabetically by name.
 * Format: { code: ISO-3166-1 alpha-2, name: string, flag: emoji }
 */
export const COUNTRIES = [
  // ── Caribbean ──────────────────────────────────────────────────────────────
  { code: "JM", name: "Jamaica",                      flag: "🇯🇲" },
  { code: "AG", name: "Antigua and Barbuda",           flag: "🇦🇬" },
  { code: "AW", name: "Aruba",                         flag: "🇦🇼" },
  { code: "BS", name: "Bahamas",                       flag: "🇧🇸" },
  { code: "BB", name: "Barbados",                      flag: "🇧🇧" },
  { code: "CW", name: "Curaçao",                       flag: "🇨🇼" },
  { code: "DM", name: "Dominica",                      flag: "🇩🇲" },
  { code: "DO", name: "Dominican Republic",            flag: "🇩🇴" },
  { code: "GD", name: "Grenada",                       flag: "🇬🇩" },
  { code: "GP", name: "Guadeloupe",                    flag: "🇬🇵" },
  { code: "GY", name: "Guyana",                        flag: "🇬🇾" },
  { code: "HT", name: "Haiti",                         flag: "🇭🇹" },
  { code: "KY", name: "Cayman Islands",                flag: "🇰🇾" },
  { code: "LC", name: "Saint Lucia",                   flag: "🇱🇨" },
  { code: "MQ", name: "Martinique",                    flag: "🇲🇶" },
  { code: "PR", name: "Puerto Rico",                   flag: "🇵🇷" },
  { code: "SR", name: "Suriname",                      flag: "🇸🇷" },
  { code: "TC", name: "Turks and Caicos Islands",      flag: "🇹🇨" },
  { code: "TT", name: "Trinidad and Tobago",           flag: "🇹🇹" },
  { code: "VC", name: "St. Vincent & the Grenadines",  flag: "🇻🇨" },
  { code: "VI", name: "US Virgin Islands",             flag: "🇻🇮" },
  // ── North America ──────────────────────────────────────────────────────────
  { code: "US", name: "United States",                 flag: "🇺🇸" },
  { code: "CA", name: "Canada",                        flag: "🇨🇦" },
  { code: "MX", name: "Mexico",                        flag: "🇲🇽" },
  // ── South America ──────────────────────────────────────────────────────────
  { code: "AR", name: "Argentina",                     flag: "🇦🇷" },
  { code: "BO", name: "Bolivia",                       flag: "🇧🇴" },
  { code: "BR", name: "Brazil",                        flag: "🇧🇷" },
  { code: "CL", name: "Chile",                         flag: "🇨🇱" },
  { code: "CO", name: "Colombia",                      flag: "🇨🇴" },
  { code: "EC", name: "Ecuador",                       flag: "🇪🇨" },
  { code: "PY", name: "Paraguay",                      flag: "🇵🇾" },
  { code: "PE", name: "Peru",                          flag: "🇵🇪" },
  { code: "UY", name: "Uruguay",                       flag: "🇺🇾" },
  { code: "VE", name: "Venezuela",                     flag: "🇻🇪" },
  // ── Africa ─────────────────────────────────────────────────────────────────
  { code: "CM", name: "Cameroon",                      flag: "🇨🇲" },
  { code: "CI", name: "Côte d'Ivoire",                 flag: "🇨🇮" },
  { code: "ET", name: "Ethiopia",                      flag: "🇪🇹" },
  { code: "GH", name: "Ghana",                         flag: "🇬🇭" },
  { code: "KE", name: "Kenya",                         flag: "🇰🇪" },
  { code: "MG", name: "Madagascar",                    flag: "🇲🇬" },
  { code: "MZ", name: "Mozambique",                    flag: "🇲🇿" },
  { code: "NG", name: "Nigeria",                       flag: "🇳🇬" },
  { code: "RW", name: "Rwanda",                        flag: "🇷🇼" },
  { code: "SN", name: "Senegal",                       flag: "🇸🇳" },
  { code: "ZA", name: "South Africa",                  flag: "🇿🇦" },
  { code: "TZ", name: "Tanzania",                      flag: "🇹🇿" },
  { code: "UG", name: "Uganda",                        flag: "🇺🇬" },
  { code: "ZM", name: "Zambia",                        flag: "🇿🇲" },
  { code: "ZW", name: "Zimbabwe",                      flag: "🇿🇼" },
  // ── Other ──────────────────────────────────────────────────────────────────
  { code: "GB", name: "United Kingdom",                flag: "🇬🇧" },
  { code: "OTHER", name: "Other",                      flag: "" },
];

/** Build a code → entry map for quick lookups */
export const COUNTRY_BY_CODE = COUNTRIES.reduce(
  (acc, c) => ({ ...acc, [c.code]: c }),
  {}
);
